/**
 * Texto compartido por todo el sitio: el cascarón (header, footer, saltos de
 * accesibilidad), los enlaces de navegación y la página 404.
 *
 * Lo que se repite en varias pantallas vive aquí una sola vez. Si una etiqueta
 * solo la usa una pantalla, va en el diccionario de esa área.
 */

export const comun = {
  /** Enlace de accesibilidad que abre el layout, antes del header. */
  saltarAlContenido: 'Saltar al contenido',

  /** Anclas del home. El `href` es el mismo en todos los idiomas. */
  navLinks: [
    { href: '#flujo', label: 'Flujo' },
    { href: '#soluciones', label: 'Soluciones' },
    { href: '#planes', label: 'Planes' },
    { href: '#aliados', label: 'Aliados' },
  ],

  header: {
    logoLabel: 'ILUMETRIA — inicio',
    navLabel: 'Navegación principal',
    contacto: 'Contacto',
    agendarDemo: 'Agendar demo',
    inversionistas: 'Inversionistas',
    /** El acceso a la plataforma MICE, que vive en otro origen. */
    plataforma: 'Platanometría',
    abrirMenu: 'Abrir menú',
    cerrarMenu: 'Cerrar menú',
  },

  footer: {
    blurb:
      'Inteligencia de datos para eventos físicos: matchmaking, captura pasiva de leads y atribución de ROI con IoT e IA.',
    instagramLabel: 'Instagram de ILUMETRIA',
    facebookLabel: 'Facebook de ILUMETRIA',
    correoLabel: (correo: string) => `Escribir a ${correo}`,
    plataforma: {
      titulo: 'Plataforma',
      flujo: 'Flujo de valor',
      soluciones: 'Soluciones',
      planes: 'Planes',
      agendarDemo: 'Agendar demo',
    inversionistas: 'Inversionistas',
      demo: 'Ver la demostración',
    },
    legal: {
      titulo: 'Legal',
      privacidad: 'Aviso de Privacidad',
      terminos: 'Términos de Servicio',
      cookies: 'Política de Cookies',
      barbunnyPrivacidad: 'Privacidad Bar Bunny',
      barbunnyEliminarCuenta: 'Eliminar cuenta Bar Bunny',
    },
    derechos: (anio: number) => `© ${anio} ILUMETRIA. Todos los derechos reservados.`,
  },

  idioma: {
    /** Etiqueta del selector para lectores de pantalla. */
    selector: 'Idioma',
    cambiarA: (idioma: string) => `Cambiar idioma a ${idioma}`,
  },

  noEncontrada: {
    eyebrow: 'Error 404',
    titulo: 'Esta página no existe',
    cuerpo: 'El enlace que seguiste ya no está disponible o se escribió mal.',
    volver: 'Volver al inicio',
  },

  /** Acciones y palabras sueltas que aparecen en más de un lugar. */
  acciones: {
    volverAlInicio: 'Volver al inicio',
  },
};
